@use "@styles/_variables/colors" as *;
@use "@styles/_variables/breakpoints" as *;

.hamburger {
  cursor: pointer;
  display: none;
  z-index: 7;

  &:focus {
    outline: none;
  }
}

@media all and (max-width: $mobile-large) {
  .hamburger {
    display: inline-block;
    margin-left: auto;

    .bar {
      background-color: #ffffff00;
      height: 0.5rem;
      width: 4.5rem;
      margin: 0.6rem 0;
      transition: 0.4s;
      svg {
        fill: $white;
        transition:
          fill 0.4s ease,
          filter 0.4s ease;
      }
    }

    &.animate {
      .bar {
        // Open state reads as "armed": the X picks up the site's gold accent.
        svg {
          fill: $gold;
          filter: drop-shadow(0 0 0.4rem $gold-semi-transparent);
        }
        // Cross arms must intersect at the middle bar's center: translate
        // FIRST (unrotated axes) by the bar-to-bar spacing — 0.5rem bar height
        // + 0.6rem collapsed sibling margin = 1.1rem — then rotate about the
        // bar's own center. (Rotating first skews the translate axes and
        // produces an off-center pinwheel.) The ±315° keeps the spin flourish.
        &:nth-child(1) {
          transform: translateY(1.1rem) rotate(-315deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          // scaleX(-1) (applied first) mirrors this arm's slash lean so the
          // X is mirror-symmetric instead of pinwheel-symmetric.
          transform: translateY(-1.1rem) rotate(315deg) scaleX(-1);
        }
      }
    }
  }
}

@media all and (max-width: $mobile-small) {
  .hamburger {
    display: inline-block;

    &.animate {
      .bar {
        &:nth-child(1) {
          // 1vw bar height + 1.2vw collapsed margin = 2.2vw center spacing.
          transform: translateY(2.2vw) rotate(-315deg);
        }

        &:nth-child(2) {
          opacity: 0;
        }

        &:nth-child(3) {
          transform: translateY(-2.2vw) rotate(315deg) scaleX(-1);
        }
      }
    }

    .bar {
      height: 1vw;
      width: 7.6vw;
      margin: 1.2vw;
      transition: 0.4s;
    }
  }
}
